import { PulseProvider } from './context/PulseProvider'
import { NuqsAdapter } from 'nuqs/adapters/react'
import { PulseMain } from './components/PulseMain'

export function PulsePage() {
  return (
    <NuqsAdapter>
      <PulseProvider>
        <PulseMain />
      </PulseProvider>
    </NuqsAdapter>
  )
}
